import React, { useRef, useState } from "react";
import { tooltipicon } from "../../assets/images";
import "./index.scss";

const HoverPopup = ({ icon, iconClass, popupClass, trigger, wrapperClass, children }) => {
    const [popupStyle, setPopupStyle] = useState(null);
    const triggerRef = useRef(null);

    const show = () => {
        if (triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setPopupStyle({
                top: rect.bottom + 10,
                left: rect.left + rect.width / 2,
            });
        }
    };

    const hide = () => setPopupStyle(null);

    return (
        <div className={`hoverPopupWrapper${wrapperClass ? ` ${wrapperClass}` : ""}`}>
            {trigger ? (
                <div
                    ref={triggerRef}
                    className="hoverPopupTrigger"
                    onMouseEnter={show}
                    onMouseLeave={hide}
                >
                    {trigger}
                </div>
            ) : (
                <img
                    ref={triggerRef}
                    src={icon || tooltipicon}
                    alt="info"
                    className={`hoverPopupIcon${iconClass ? ` ${iconClass}` : ""}`}
                    onMouseEnter={show}
                    onMouseLeave={hide}
                />
            )}
            {popupStyle && (
                <div
                    className={`hoverPopupPopup${popupClass ? ` ${popupClass}` : ""}`}
                    style={popupStyle}
                    onMouseEnter={show}
                    onMouseLeave={hide}
                >
                    <div className="hoverPopupArrow" />
                    {children}
                </div>
            )}
        </div>
    );
};

export default HoverPopup;
